import React from 'react';

const EmptyImageSideOrder = () => {
  return (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#F2F5FC" height="80" rx="6" width="80" />
      <path
        d="M21 59V25.8284L23 27.8284V59C23 60.1046 23.8954 61 25 61H55C55.3391 61 55.6585 60.9156 55.9383 60.7667L57.3839 62.2123C56.7181 62.7072 55.8933 63 55 63H25C22.7909 63 21 61.2091 21 59Z"
        fill="#1B42B2"
      />
      <path
        d="M25 48V29.8284L27 31.8284V41.5858L31.8787 36.7071L33.2929 38.1213L27 44.4142V48C27 48.5523 27.4477 49 28 49H44.1716L46.1716 51H28C26.3431 51 25 49.6569 25 48Z"
        fill="#1B42B2"
      />
      <path
        clipRule="evenodd"
        d="M45 27C42.7909 27 41 28.7909 41 31C41 33.2091 42.7909 35 45 35C47.2091 35 49 33.2091 49 31C49 28.7909 47.2091 27 45 27ZM43 31C43 29.8954 43.8954 29 45 29C46.1046 29 47 29.8954 47 31C47 32.1046 46.1046 33 45 33C43.8954 33 43 32.1046 43 31Z"
        fill="#1B42B2"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M21.1906 19.7764L18.7071 17.2929C18.3166 16.9024 17.6834 16.9024 17.2929 17.2929C16.9024 17.6834 16.9024 18.3166 17.2929 18.7071L61.2929 62.7071C61.6834 63.0976 62.3166 63.0976 62.7071 62.7071C63.0976 62.3166 63.0976 61.6834 62.7071 61.2929L59 57.5858V21C59 18.7909 57.2091 17 55 17H25C23.2176 17 21.7076 18.1658 21.1906 19.7764ZM27 25.5858L44 42.5858L47.2929 39.2929C47.6834 38.9024 48.3166 38.9024 48.7071 39.2929L53 43.5858V24C53 23.4477 52.5523 23 52 23H28C27.4477 23 27 23.4477 27 24V25.5858ZM45.4142 44L50.4142 49H52C52.5523 49 53 48.5523 53 48V46.4142L48 41.4142L45.4142 44ZM52.3892 50.975L57 55.5858V21C57 19.8954 56.1046 19 55 19H25C23.8954 19 23 19.8954 23 21V21.5858L25.025 23.6108C25.2158 22.1378 26.475 21 28 21H52C53.6569 21 55 22.3431 55 24V48C55 49.525 53.8622 50.7842 52.3892 50.975Z"
        fill="#1B42B2"
        fillRule="evenodd"
      />
      <path
        d="M46 57H34C33.4477 57 33 56.5523 33 56C33 55.4477 33.4477 55 34 55H46C46.5523 55 47 55.4477 47 56C47 56.5523 46.5523 57 46 57Z"
        fill="#1B42B2"
      />
    </svg>
  );
};

export default EmptyImageSideOrder;
